/**
 * Limba în care i se vorbește vizitatorului - UN SINGUR loc unde se decide.
 *
 * Regula produsului: niciun text vizibil vizitatorului nu e engleză „implicită".
 * Tot ce citește el (chrome-ul widgetului, notele de eroare, salutul, mesajele
 * fallback ale backendului) urmează `business.language` din configul appului.
 * Persona LLM își alege singură limba, din prompt - asta e despre textele
 * NOASTRE, cele scrise de noi în cod.
 *
 * Stă în `shared` fiindcă e nevoie de ea de ambele părți: SDK-ul o folosește
 * pentru chrome (`uiText.ts`, `proactivity/text.ts`), backendul pentru
 * răspunsurile pe care le compune el (`fallbackAgent.ts`, `routes/demo.ts`).
 * Două implementări ar începe să ghicească diferit exact acolo unde nimeni nu
 * se uită - un `ro-RO` tradus într-o parte și nu în cealaltă.
 */
export type UiLanguage = "ro" | "en";

/**
 * `business.language` e text liber scris de scan („ro", „ro-RO", „Romanian",
 * „română"), deci nu se compară pe egalitate: orice începe cu „ro" sau conține
 * „roman" e română, restul cade pe engleză. Un fallback greșit costă o
 * propoziție într-o limbă străină; o comparație strictă ar costa-o mereu.
 */
export function resolveLanguage(language: string | undefined): UiLanguage {
  const value = (language ?? "").trim().toLowerCase();
  if (value.startsWith("ro") || value.includes("roman") || value.includes("român")) return "ro";
  return "en";
}
